import type { GetUsersResult } from '../../api/get-users/getUsers.types';
import type { SortDirection } from './UsersDataContext.types';

export const INITIAL_USERS_RESPONSE: GetUsersResult = {
  elements: [],
  total: 0,
};

export const INITIAL_DATA_STATE = {
  pageSize: 25,
  pageIndex: 0,
  sortBy: 'lastModified',
  sortDirection: 'asc' as SortDirection,
};
